export const customers = {
  title: 'Clientes',
  description: 'Gestione sus clientes',
  form: {
    createTitle: 'Nuevo cliente',
    editTitle: 'Editar cliente',
    fields: {
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      address: 'Dirección',
      notes: 'Notas',
      isActive: 'Activo',
      solde: 'Saldo'
    },
    placeholders: {
      name: 'Ingrese el nombre del cliente',
      email: 'Ingrese el correo electrónico del cliente',
      phone: 'Ingrese el número de teléfono',
      address: 'Ingrese la dirección',
      notes: 'Agregue notas sobre el cliente'
    },
    validations: {
      required: 'Este campo es requerido',
      email: 'Por favor ingrese un correo electrónico válido',
      phone: 'Por favor ingrese un número de teléfono válido',
      minLength: 'Este campo debe tener al menos {min} caracteres',
      maxLength: 'Este campo no debe exceder {max} caracteres',
      positiveNumber: 'El monto debe ser positivo'
    },
    create: 'Crear',
    update: 'Actualizar',
    cancel: 'Cancelar',
    submitting: 'Guardando...'
  },
  columns: {
    name: 'Nombre',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    address: 'Dirección',
    notes: 'Notas',
    isActive: 'Estado',
    solde: 'Saldo',
    createdAt: 'Creado el',
    updatedAt: 'Actualizado el',
    lastSync: 'Última sincronización',
    basicInfo: 'Información básica',
    financialInfo: 'Detalles financieros',
    systemInfo: 'Información del sistema'
  },
  filters: {
    search: {
      label: 'Buscar',
      placeholder: 'Buscar un cliente...'
    },
    status: {
      label: 'Estado',
      active: 'Activo',
      inactive: 'Inactivo'
    }
  },
  actions: {
    newCustomer: 'Nuevo cliente',
    edit: 'Editar',
    delete: 'Eliminar',
    view: 'Ver'
  },
  confirmations: {
    delete: '¿Está seguro de que desea eliminar este cliente?',
    deleteSuccess: 'Cliente eliminado con éxito',
    createSuccess: 'Cliente creado con éxito',
    updateSuccess: 'Cliente actualizado con éxito'
  },
  errors: {
    load: 'Error al cargar los clientes',
    create: 'Error al crear el cliente',
    update: 'Error al actualizar el cliente',
    delete: 'Error al eliminar el cliente'
  },
  pagination: {
    totalItems: 'Total de elementos',
    previous: 'Anterior',
    next: 'Siguiente',
    page: 'Página',
    showing: 'Mostrando',
    to: 'a',
    of: 'de',
    items: 'elementos'
  },
  currency: 'Dh'
}; 